import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "pl-6 py-4 flex items-center border-2 border-t border-gray-200" };
const _hoisted_2 = { class: "capitalize text-primary font-bold overflow-ellipsis overflow-hidden whitespace-nowrap" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "fas fa-lock text-xs ml-2" }, null, -1);
const _hoisted_4 = { class: "fixed right-0 top-0 mr-5 mt-5 z-50" };
const _hoisted_5 = { class: "hidden cursor-pointer hover:underline select-none md:block truncate w-96" };
const _hoisted_6 = { class: "pl-2 max-w truncate" };
const _hoisted_7 = { class: "inline-block" };
const _hoisted_8 = { class: "md:hidden flex flex-row items-center" };
const _hoisted_9 = { class: "flex-1 my-4 flex flex-row select-none items-center max-w-full" };
const _hoisted_10 = { class: "pl-2 max-w truncate" };
const _hoisted_11 = { class: "inline-block" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("svg", {
    class: "mx-auto h-12 w-12 text-gray-400",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "vector-effect": "non-scaling-stroke",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    })
], -1);
const _hoisted_13 = /*#__PURE__*/ _createTextVNode(" Securely logging out and resending email ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LanguageSelector = _resolveComponent("LanguageSelector");
    const _component_empty_table_state = _resolveComponent("empty-table-state");
    const _component_file_manager = _resolveComponent("file-manager");
    const _component_spinner_modal = _resolveComponent("spinner-modal");
    const _component_idle_component = _resolveComponent("idle-component");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('share.readonlyTitle')), 1),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_LanguageSelector)
            ])
        ]),
        _createVNode(_component_file_manager, {
            class: "block h-full px-2",
            data: _ctx.temporaryShares,
            openWithSingleClick: "",
            withFiltering: "",
            onOpenItem: _ctx.openFileById,
            displaySidebar: false,
            headers: _ctx.headers
        }, {
            "data-name": _withCtx((rowData) => [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("em", {
                        class: _normalizeClass(_ctx.getIcon(_ctx.getFileType(rowData.row.extension)) + ' ' + _ctx.getIconColor(_ctx.getFileType(rowData.row.extension)))
                    }, null, 2),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(rowData.row.name), 1),
                    _createElementVNode("span", _hoisted_7, "." + _toDisplayString(rowData.row.extension), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("em", {
                            class: _normalizeClass(_ctx.getIcon(_ctx.getFileType(rowData.row.extension)) + ' ' + _ctx.getIconColor(_ctx.getFileType(rowData.row.extension)))
                        }, null, 2),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(rowData.row.name), 1),
                        _createElementVNode("span", _hoisted_11, "." + _toDisplayString(rowData.row.extension), 1)
                    ])
                ])
            ]),
            emptyState: _withCtx(() => [
                _createVNode(_component_empty_table_state, null, {
                    icon: _withCtx(() => [
                        _hoisted_12
                    ]),
                    header: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('filter.foldersNotFound')), 1)
                    ]),
                    content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('filter.addItemsMessage')), 1)
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["data", "onOpenItem", "headers"]),
        (_ctx.logoutSpinner)
            ? (_openBlock(), _createBlock(_component_spinner_modal, { key: 0 }, {
                message: _withCtx(() => [
                    _hoisted_13
                ]),
                _: 1
            }))
            : _createCommentVNode("", true),
        _createVNode(_component_idle_component, {
            onTriggerLogout: _cache[0] || (_cache[0] = ($event) => (_ctx.logoutSpinner = true))
        })
    ], 64));
}
